import { Controller } from 'stimulus';

import $ from 'jquery';
import sortable from 'jquery-ui/ui/widgets/sortable';

export default class extends Controller {
  static values = {
    url: String
  }

  connect() {
    this._token = $('meta[name="csrf-token"]').attr('content');
    this._reorderBtn = $('#permits-reorder');
    this._reorderingState = 'disabled';

    $(this.element).sortable();
    $(this.element).sortable('disable');

    $(this._reorderBtn).on('click', () => {
      if (this._reorderingState == 'disabled') {
        $(this.element).sortable('enable');
        this._reorderingState = 'enabled';
        this._reorderBtn.removeClass('btn-default');
        this._reorderBtn.addClass('btn-primary');
        $('[data-behavior=permits-reorder-icon]').show();
        this._reorderBtn.text('Save new order');
      } else {
        $(this.element).sortable('disable');
        this._reorderingState = 'disabled';
        this._reorderBtn.removeClass('btn-primary');
        this._reorderBtn.addClass('btn-default');
        $('[data-behavior=permits-reorder-icon]').hide();
        this._reorderBtn.text('Reorder permits');

        $.ajax({
          headers: { 'X-CSRF-Token': this._token },
          type: 'POST',
          url: this.urlValue,
          data: { ids: $(this.element).sortable('toArray') }
        })
      }
    })
  }
}
